import { StyleSheet } from 'aphrodite';
import constants from '../../../../constants/styles';

let {
  STATUS_PARENT_LABEL_COLOR,
  STATUS_PARENT_VALUE_COLOR,
  STATUS_PARENT_BG_COLOR,
  STATUS_PARENT_HOVER_BG_COLOR,
  TABLE_BG_COLOR,
  STATUS_PARENT_VALUE_COLOR_HEADER,
  STATUS_RED_COLOR,
  STATUS_GREEN_COLOR,
  STATUS_YELLOW_COLOR
} = constants;

let styles = {
  bases: {
    display: 'flex',
    minWidth: 820,
    backgroundColor: STATUS_PARENT_BG_COLOR,
    padding: '20px 30px 25px',
    borderRadius: 8,
    marginBottom: 10,
    position: 'relative',
    width: '95%',
    textTransform: 'uppercase'
  },

  base: {
    display: 'flex',
    minWidth: 820,
    backgroundColor: STATUS_PARENT_BG_COLOR,
    padding: '20px 30px 25px',
    borderRadius: 8,
    position: 'relative',
    textTransform: 'uppercase',
    borderBottom: `1px solid ${TABLE_BG_COLOR}`,
    width: '95%',
    ':hover': {
      backgroundColor: STATUS_PARENT_HOVER_BG_COLOR
    }
  },

  field: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '1.1em',
    color: STATUS_PARENT_VALUE_COLOR,
    paddingLeft: 1,
    paddingRight: 0,
    position: 'relative',
    fontWeight: 'normal',
    textTransform: 'uppercase'
  },
  fieldsHeader: {
    color: STATUS_PARENT_VALUE_COLOR_HEADER,
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 1,
    paddingRight: 0,
    position: 'relative',
    fontWeight: 800,
    fontSize: '15px',
    textTransform: 'uppercase'
  },
  label: {
    fontSize: '0.7em',
    fontWeight: 'normal',
    textTransform: 'uppercase',
    color: STATUS_PARENT_LABEL_COLOR,
    marginBottom: 5,
    width: '100%',
    textAlign: 'center'
  },
  green: {
    height: 10,
    width: 10,
    backgroundColor: STATUS_GREEN_COLOR,
    borderRadius: '50%'
  },
  red: {
    height: 10,
    width: 10,
    backgroundColor: STATUS_RED_COLOR,
    borderRadius: '50%'
  },
  yellow: {
    height: 10,
    width: 10,
    backgroundColor: STATUS_YELLOW_COLOR,
    borderRadius: '50%'
  },
  light: {
    justifyContent: 'center',
    width: '8%',
    paddingLeft: 25
  },
  healthHeader: {
    width: '10.3%'
  },
  rpHeader: {
    width: '15%'
  },
  rp: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '15%'
  },
  location: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '19%'
  },
  locationHeader: {
    width: '19%'
  },
  name: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  lastSeen: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '19%'
  },
  apHeader: {
    width: '19%'
  },
  heading: {
    fontSize: 16,
    textTransform: 'uppercase',
    fontWeight: 500
  },
  zone: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '19%'
  },
  zoneHeader: {
    width: '19%'
  },
  apmacHeader: {
    width: '20%'
  },
  lastApMac: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '20%'
  },
  noDataRow: {
    width: '95%'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/status/referencepoint/referencePointRow.styles.js